export enum MenuOptions {
    DASHBOARD = 'dashboard',
    SETTINGS = 'settings',
    ANOMALIES = 'anomalies',
    INSIGHTS = 'insights',
    ADMIN = 'admin',
}

export enum AdminMenuOptions {
    CUSTOMERS = 'customers',
    APNS = 'apns',
}

export enum InsightsSubMenu {
    REPORTS = 'Reports',
    ALERTS = 'Alerts',
    ACTIVITY = 'Activity',
    TRAFFIC_CLASSES = 'Traffic Classes',
}

export enum InsightType {
    REPORT = 'report',
    ALERT = 'alert',
    ACTIVITY = 'activity',
    TRAFFIC_CLASSES = 'traffic-classes',
}

export enum ErrorCode {
    UNAUTHENTICATED_401 = 401,
    UNAUTHORIZED_403 = 403,
    NOT_FOUND_404 = 404,
    UNPROCESSABLE_CONTENT_422 = 422,
    INTERNAL_SERVER_ERROR_500 = 500
}

export enum SettingsSubMenu {
    ANOMALIES = 'Anomalies',
    EXCEPTIONS = 'Exceptions',
    GENERAL = 'General',
    TRAFFIC_CLASSES = 'Traffic Classes'
}

export enum DestinationTreeColumns {
    DESTINATION = 'destination',
    IP = 'ip',
    VOLUME = 'volume',
    PERCENTAGE = 'percentage',
    PORT = 'port'
}

export enum OnboardingStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    DRAFT = 'DRAFT',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}